import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { selectFluxPersonalizedFormShowInstructions, selectFluxPersonalizedFormShowSuccessModal, setShowSuccessModal } from 'redux/reducers/fluxPersonalizedFormReducer';
import { setCurrentTab } from 'redux/reducers/fluxPersonalizedLayoutReducer';
import { openRight } from 'redux/reducers/sidebarsReducer';
import { store } from 'redux/store';
import Instructions from 'components/Flux/Personalized/New/Instructions';
import NewPersonalizedStudy from 'components/Flux/Personalized/New';
import PersonalizedFormMobile from 'components/Flux/Personalized/Mobile/Form';
import Dialog from 'components/DesignSystem/Dialog';
import DialogBody from 'components/DesignSystem/Dialog/Body';
import useIsMobile from 'utils/hooks/useIsMobile';
import './index.scss';

export default function New() {
  const showInstructions = useSelector(selectFluxPersonalizedFormShowInstructions);
  const showSuccessModal = useSelector(selectFluxPersonalizedFormShowSuccessModal);
  const isMobile = useIsMobile();

  useEffect(() => {
    store.dispatch(setCurrentTab('new'));
    store.dispatch(openRight());
  });

  const successDialog = (
    <Dialog
      open={showSuccessModal}
      dismiss={() => store.dispatch(setShowSuccessModal(false))}
      closeButton
      type="success"
    >
      <DialogBody>Seu estudo foi enviado com sucesso!</DialogBody>
    </Dialog>
  );

  // No mobile o wrapper nao renderiza a RightSidebar, entao o formulario vem da view.
  // Ele continua visivel depois de "Adicionar Cenario" (horizonte travado, como no desktop)
  // e o construtor de cenarios aparece logo abaixo.
  if (isMobile) {
    return (
      <div className="new-personalized-mobile">
        {successDialog}
        {showInstructions && <Instructions />}
        <PersonalizedFormMobile />
        {!showInstructions && <NewPersonalizedStudy />}
      </div>
    );
  }

  return (
    <>
      {successDialog}
      {showInstructions && <Instructions />}
      {!showInstructions && <NewPersonalizedStudy />}
    </>
  );
}
